import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appDigitalDisplay]'
})
export class DigitalDisplayDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    const value = this.el.nativeElement.innerText;
    this.el.nativeElement.innerHTML = this.convertToDigitalDisplay(value);
    this.renderer.setStyle(this.el.nativeElement, 'display', 'flex');
    this.renderer.setStyle(this.el.nativeElement, 'gap', '5px');
  }

  private convertToDigitalDisplay(value: string): string {
    return value.split('').map(char => {
      if (char === ',') {
        return `<span style="display: inline-block; width: 3px; text-align: center; color: #FFF">,</span>`;
      }
      return `<span class="digital-number">${char}</span>`;
    }).join('');
  }

}
